<div
  class="explore-card"
>
  <div class="card-layout">
    <div class="icon-wrapper">
      <mat-icon class="explore-icon">{{ icon() }}</mat-icon>
    </div>
    <div class="content-wrapper">
      <a class="explore-title" [href]="link()" target="_blank" rel="noopener noreferrer">
        <span class="explore-title-text">{{ title() }}</span>
        <mat-icon class="external-link-icon">open_in_new</mat-icon>
      </a>
      <p class="explore-description">{{ description() }}</p>
    </div>
  </div>
</div>
